import { SelectOption } from './SelectOption';

export class ColorSelectOption extends SelectOption {
  readonly #color?: string;

  constructor(value: string, label?: string, color?: string) {
    super(value, label);
    this.#color = color;
  }

  get color(): string | undefined {
    return this.#color;
  }
}
